<template>
    <div class="bg-primary-gradient">
        <div class="h-screen overflow-y-auto bg-image-group bg-no-repeat bg-cover p-3 sm:p-0">


            <div class="flex items-center relative bg-no-repeat"
                 :class="['bg-image-iphones']">

                <!-- == Textos == -->
                <transition name="fade" mode="out-in" :duration="300">
                    <div class="h-screen hidden lg:flex px-8 flex-col w-2/4 items-center justify-center ">
               
                        <!-- == transition text 1 == -->
                        <div >
                            <h1 class="headline1">
                                Superprático é 
                            </h1>
                            <h1 class="headline1 ">
                                a 
                                <span class="text-neutral-900">plataforma </span>
                            </h1>
                            <h1 class="headline1 ">
                                <span class="text-neutral-900">completa</span>
                                <span class="headline1  mb-4"> para </span>
                            </h1>
                            <h1 class="headline1  mb-4">
                                formação de
                            </h1>
                            <h1 class="headline1  mb-4">
                                condutores
                            </h1>
                            <p class="headline3" >
                                Atua em todas etapas do
                            </p>
                            <p class="headline3" >
                                processo para certificar o
                            </p>
                            <p class="headline3" >
                                cumprimento da legislação
                            </p>
                        </div>

                    </div>
                </transition>

                <div class="w-full mx-auto max-w-2xl sm:py-5 relative z-0 visible">
                    <slot></slot>  
                </div>

                <!-- == offset == -->
                <div class="hidden lg:flex w-2/4">
                </div>
            </div>
        </div>
    </div>
</template>
<script lang='ts'>
import { defineComponent, ref } from 'vue';
import { validEmail, validPassword, required } from '@/utils/validators';

import { logoPilotar, groupVectorTop, groupIphone, groupVector,  iphone, simulatorVirtual } from '@/assets/images';
import { useRouter } from 'vue-router';

const PerfilMainView = defineComponent({
    name: 'PerfilMainView',
    components: {
        
    }, 

    setup () {
        const routeIndex = ref();
        const router = useRouter();

        const validate = ref(false);

        router.afterEach((to) => {
            routeIndex.value = to.meta.index;  
           
        });

        const submit = ( ) => {
            router.push({ name: 'contatos' });
        };

        return { 
            router,
            routeIndex,
            groupVectorTop,
            groupIphone,
            groupVector,
            simulatorVirtual,
            iphone,
            logoPilotar,
            validEmail, 
            submit,
            validate, 
            validPassword, 
            required 
        };
    }
});
export default PerfilMainView;
</script>

<style scoped>
.bg-image-group {
    background-image: url(../../assets/images/group-vector.png);
}
.bg-image-iphones {
    background-image: url(../../assets/images/cell-phones.svg);
    background-size: 20%;
    background-position: right 10% top 50%;
}
.bg-primary-gradient {
    background: linear-gradient(180deg, #4494FF 0%, #236DD1 100%);
}

@media (max-width: 639px) {
    .bg-image-group {
        background-image: none;
    }
}

@media (max-width: 1168px) {
    .bg-image-iphones {
        background-image: none;
    }

}
</style>
